"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/avalanche-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 9.3.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1Api = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class V1Api extends runtime.BaseAPI {
    /**
     * Get the estimated gas cost of a transaction
     */
    async estimateGasRaw(requestParameters, initOverrides) {
        if (requestParameters.data === null || requestParameters.data === undefined) {
            throw new runtime.RequiredError('data', 'Required parameter requestParameters.data was null or undefined when calling estimateGas.');
        }
        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from', 'Required parameter requestParameters.from was null or undefined when calling estimateGas.');
        }
        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to', 'Required parameter requestParameters.to was null or undefined when calling estimateGas.');
        }
        if (requestParameters.value === null || requestParameters.value === undefined) {
            throw new runtime.RequiredError('value', 'Required parameter requestParameters.value was null or undefined when calling estimateGas.');
        }
        const queryParameters = {};
        if (requestParameters.data !== undefined) {
            queryParameters['data'] = requestParameters.data;
        }
        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }
        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }
        if (requestParameters.value !== undefined) {
            queryParameters['value'] = requestParameters.value;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/gas/estimate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GasEstimateFromJSON)(jsonValue));
    }
    /**
     * Get the estimated gas cost of a transaction
     */
    async estimateGas(requestParameters, initOverrides) {
        const response = await this.estimateGasRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get account details by address
     */
    async getAccountRaw(requestParameters, initOverrides) {
        if (requestParameters.pubkey === null || requestParameters.pubkey === undefined) {
            throw new runtime.RequiredError('pubkey', 'Required parameter requestParameters.pubkey was null or undefined when calling getAccount.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/account/{pubkey}`.replace(`{${"pubkey"}}`, encodeURIComponent(String(requestParameters.pubkey))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.AccountFromJSON)(jsonValue));
    }
    /**
     * Get account details by address
     */
    async getAccount(requestParameters, initOverrides) {
        const response = await this.getAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the current recommended gas fees to use in a transaction  * For EIP-1559 transactions, use `maxFeePerGas` and `maxPriorityFeePerGas` * For Legacy transactions, use `gasPrice`
     */
    async getGasFeesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/gas/fees`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GasFeesFromJSON)(jsonValue));
    }
    /**
     * Get the current recommended gas fees to use in a transaction  * For EIP-1559 transactions, use `maxFeePerGas` and `maxPriorityFeePerGas` * For Legacy transactions, use `gasPrice`
     */
    async getGasFees(initOverrides) {
        const response = await this.getGasFeesRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get information about the running coinstack
     */
    async getInfoRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.BaseInfoFromJSON)(jsonValue));
    }
    /**
     * Get information about the running coinstack
     */
    async getInfo(initOverrides) {
        const response = await this.getInfoRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get token metadata
     */
    async getTokenMetadataRaw(requestParameters, initOverrides) {
        if (requestParameters.contract === null || requestParameters.contract === undefined) {
            throw new runtime.RequiredError('contract', 'Required parameter requestParameters.contract was null or undefined when calling getTokenMetadata.');
        }
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getTokenMetadata.');
        }
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getTokenMetadata.');
        }
        const queryParameters = {};
        if (requestParameters.contract !== undefined) {
            queryParameters['contract'] = requestParameters.contract;
        }
        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/metadata/token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.TokenMetadataFromJSON)(jsonValue));
    }
    /**
     * Get token metadata
     */
    async getTokenMetadata(requestParameters, initOverrides) {
        const response = await this.getTokenMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get transaction details
     */
    async getTransactionRaw(requestParameters, initOverrides) {
        if (requestParameters.txid === null || requestParameters.txid === undefined) {
            throw new runtime.RequiredError('txid', 'Required parameter requestParameters.txid was null or undefined when calling getTransaction.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/tx/{txid}`.replace(`{${"txid"}}`, encodeURIComponent(String(requestParameters.txid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.TxFromJSON)(jsonValue));
    }
    /**
     * Get transaction details
     */
    async getTransaction(requestParameters, initOverrides) {
        const response = await this.getTransactionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get transaction history by address
     */
    async getTxHistoryRaw(requestParameters, initOverrides) {
        if (requestParameters.pubkey === null || requestParameters.pubkey === undefined) {
            throw new runtime.RequiredError('pubkey', 'Required parameter requestParameters.pubkey was null or undefined when calling getTxHistory.');
        }
        const queryParameters = {};
        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }
        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/account/{pubkey}/txs`.replace(`{${"pubkey"}}`, encodeURIComponent(String(requestParameters.pubkey))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.BaseTxHistoryTxFromJSON)(jsonValue));
    }
    /**
     * Get transaction history by address
     */
    async getTxHistory(requestParameters, initOverrides) {
        const response = await this.getTxHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Broadcast signed raw transaction
     */
    async sendTxRaw(requestParameters, initOverrides) {
        if (requestParameters.sendTxBody === null || requestParameters.sendTxBody === undefined) {
            throw new runtime.RequiredError('sendTxBody', 'Required parameter requestParameters.sendTxBody was null or undefined when calling sendTx.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.SendTxBodyToJSON)(requestParameters.sendTxBody),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Broadcast signed raw transaction
     */
    async sendTx(requestParameters, initOverrides) {
        const response = await this.sendTxRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.V1Api = V1Api;
